import { memo } from 'react';
import { useApplyExportSearch } from './use-apply-export-search';

/**
 * Headless mount point for `useApplyExportSearch`. Rendered once inside the search
 * layout (within scope + router context) so an `?export-search=` link is applied
 * to the params store on load.
 */
export const ExportSearchLoader = memo(() => {
  useApplyExportSearch();
  return null;
});

ExportSearchLoader.displayName = 'ExportSearchLoader';
